module.exports = __webpack_public_path__ + "static/img/downloadBottom.6364a6e3.png";